import { fmtPctN, inr, usd4 } from './monetizationMath';
import type { TargetKey } from './targets';

const num2 = (v: number) => v.toFixed(2);

export interface TileSpec {
  key: TargetKey;
  label: string;
  format: (v: number) => string;
  info?: string;
}

/** The seven tiles, in the order of the spec's section 3. */
export const TILES: TileSpec[] = [
  {
    key: 'arpdauUsd',
    label: 'ARPDAU',
    format: usd4,
    info: 'Net of refunds: (IAP + ads - refunds) / DAU, weighted over the range. The Segments tab shows ARPDAU gross of refunds.',
  },
  {
    key: 'payerRate',
    label: 'Payer rate (daily)',
    format: (v) => fmtPctN(v, 2),
    info: 'Daily-weighted: payers summed over the days / DAU summed over the days. Not a share of distinct players in the range.',
  },
  { key: 'arppuInr', label: 'ARPPU (INR)', format: (v) => inr(v) },
  { key: 'cartToPurchase', label: 'Cart to purchase', format: (v) => fmtPctN(v, 1) },
  {
    key: 'adImpressionsPerDau',
    label: 'Ad impressions per DAU (daily)',
    format: num2,
    info: 'Daily-weighted: ad impressions summed over the days / DAU summed over the days.',
  },
  { key: 'repeatPayers7d', label: 'Repeat payers (7 days)', format: (v) => fmtPctN(v, 1) },
  {
    key: 'refundShare',
    label: 'Refund share',
    format: (v) => fmtPctN(v, 2),
    info: 'Refunds / gross IAP revenue, on days the backend export covers.',
  },
];
